var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHighlightLeftTop = function SvgHighlightLeftTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.602 8.266S.865-.637 8.79.237c7.926.875 2.957 4.527 1.311 6.187-1.645 1.661-3.65 3.511-3.65 3.511S.849 14.943.602 8.266Z",
    clipRule: "evenodd"
  })));
};
export { SvgHighlightLeftTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjYwMTk5IDguMjY1OTlDMC42MDE5OSA4LjI2NTk5IDAuODY0OTg5IC0wLjYzNzAxMiA4Ljc4OTk5IDAuMjM2OTg4QzE2LjcxNiAxLjExMTk5IDExLjc0NyA0Ljc2Mzk5IDEwLjEwMSA2LjQyMzk5QzguNDU1OTkgOC4wODQ5OSA2LjQ1MDk5IDkuOTM0OTkgNi40NTA5OSA5LjkzNDk5QzYuNDUwOTkgOS45MzQ5OSAwLjg0ODk5IDE0Ljk0MyAwLjYwMTk5IDguMjY1OTlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";